export default __webpack_public_path__ + "static/N0018-50ba32346839a52c0085a09a55905771.png";